import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hydundaixcentcabinpune() {



  const cardData = {




keyword: "Hyundai Xcent Cabs in Pune",

headingDescription: "Garud Cab Service provides comfortable and affordable Hyundai Xcent Cabs in Pune for airport transfers, corporate travel, family journeys, local transportation, railway station transfers, sightseeing, and long-distance travel. Hyundai Xcent offers a practical combination of comfortable seating, efficient performance, useful luggage space, and a smooth ride, making it suitable for individuals, couples, and small families. Customers can book a chauffeur-driven Hyundai Xcent for one-way trips, round trips, airport pickup and drop, business travel, and customized travel plans. With clean and well-maintained vehicles, experienced drivers, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service provides a convenient cab experience from Pune to popular destinations across Maharashtra and nearby regions.",

topPlaces: [
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill destination near Pune known for scenic valleys, waterfalls, forts, lakes, and pleasant mountain surroundings. Hyundai Xcent is a practical choice for couples, individuals, and small families traveling from Pune for a weekend getaway. Garud Cab Service provides chauffeur-driven cabs for direct journeys, return trips, and customized sightseeing around Lonavala."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station famous for viewpoints, strawberry farms, Venna Lake, waterfalls, and beautiful Sahyadri landscapes. Travelers can choose a Hyundai Xcent for a comfortable private journey from Pune, especially for smaller groups with moderate luggage. The cab can be booked for one-way travel, round trips, and sightseeing plans."
  },
  {
    title: "Mumbai",
    description: "Mumbai is a major business, entertainment, and transportation hub frequently visited from Pune for corporate meetings, airport transfers, shopping, medical appointments, and family work. Hyundai Xcent offers a comfortable option for individuals and small groups traveling between Pune and Mumbai. Garud Cab Service provides flexible pickup and drop facilities with professional chauffeurs."
  },
  {
    title: "Nashik",
    description: "Nashik is an important Maharashtra destination known for Trimbakeshwar, Panchavati, temples, vineyards, and cultural attractions. A Hyundai Xcent is suitable for couples, small families, and business travelers heading from Pune to Nashik. Customers can arrange private transportation for religious visits, sightseeing, business travel, and return journeys."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year for Sai Baba Darshan. Hyundai Xcent provides a comfortable and economical option for individuals, couples, and small families traveling from Pune. Garud Cab Service offers chauffeur-driven bookings for one-way journeys, return trips, and customized religious travel."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is known for Mahalaxmi Temple, Panhala Fort, Rankala Lake, traditional cuisine, and rich cultural heritage. Travelers from Pune can choose a Hyundai Xcent for a comfortable journey when traveling with a smaller group. The vehicle is suitable for direct transportation as well as sightseeing around Kolhapur and nearby attractions."
  },
  {
    title: "Goa",
    description: "Goa is a popular destination for beach holidays, couples' trips, family vacations, and weekend breaks from Pune. Hyundai Xcent provides a private travel option for smaller groups carrying moderate luggage. Customers can book a chauffeur-driven cab for one-way or round-trip Goa travel with flexible pickup and travel arrangements."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal getaway known for beaches, sea forts, scenic surroundings, and peaceful weekend experiences. Hyundai Xcent is suitable for couples and small families planning a private journey from Pune. Garud Cab Service offers convenient cab bookings for direct travel, return journeys, and customized Alibaug sightseeing."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is an important heritage and religious destination featuring Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. A Hyundai Xcent can be a practical choice for individuals and smaller families traveling from Pune. Travelers can customize their journey to include multiple historical and religious attractions."
  },
  {
    title: "Satara",
    description: "Satara is known for its scenic Sahyadri landscapes, Kaas Plateau, Thoseghar Waterfalls, and historic attractions such as Ajinkyatara Fort. It is a convenient destination for nature lovers and weekend travelers from Pune. Hyundai Xcent provides a comfortable private cab option for smaller groups planning direct travel or sightseeing around the Satara region."
  }
],




"services": [
{
"name": "Xcent Cab Service in Pune",
"description": "Book Xcent Cab Service in Pune for comfortable and reliable chauffeur-driven transportation with a well-maintained Hyundai Xcent and convenient AC travel. The service is suitable for local rides, airport transfers, corporate travel, family trips, sightseeing, personal journeys, and outstation transportation from Pune."
},
{
"name": "Hyundai Xcent Rental Pune",
"description": "Choose Hyundai Xcent Rental Pune for convenient private transportation with a professional driver and comfortable sedan interiors. Hire the vehicle for local travel, airport transfers, business meetings, sightseeing, family journeys, one-way trips, round trips, and outstation travel according to your schedule."
},
{
"name": "Hyundai Xcent Taxi Booking Pune",
"description": "Make Hyundai Xcent Taxi Booking Pune for a scheduled and comfortable sedan journey with an experienced chauffeur. Enjoy convenient pickup and drop arrangements, air-conditioned interiors, spacious seating, and reliable transportation for office travel, airport transfers, personal visits, sightseeing, and outstation journeys."
},
{
"name": "Sedan Cab Service Pune",
"description": "Book Sedan Cab Service Pune with a comfortable Hyundai Xcent for private chauffeur-driven transportation across the city and nearby destinations. The service is suitable for individuals, couples, families, corporate passengers, tourists, airport travelers, and customers requiring convenient local or outstation cab service."
},
{
"name": "Hyundai Xcent Car Booking Pune",
"description": "Reserve Hyundai Xcent Car Booking Pune for comfortable and convenient private transportation with a professional chauffeur. Select the vehicle for local travel, airport transfers, corporate meetings, family trips, sightseeing, hotel transfers, one-way journeys, and planned outstation travel from Pune."
},
{
"name": "Xcent Outstation Cab Pune",
"description": "Choose Xcent Outstation Cab Pune for comfortable long-distance travel in a reliable Hyundai Xcent sedan with an experienced driver. The service is suitable for destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Goa, and other cities with one-way or round-trip options."
},
{
"name": "Hyundai Xcent Airport Transfer Pune",
"description": "Book Hyundai Xcent Airport Transfer Pune for convenient transportation to and from Pune Airport. Enjoy scheduled pickup, luggage assistance, comfortable AC interiors, and direct airport transfers with a professional chauffeur for individuals, families, business travelers, tourists, and corporate passengers."
},
{
"name": "Pune Xcent Car Hire",
"description": "Hire a Pune Xcent Car with a professional chauffeur for comfortable and private transportation without the need to drive yourself. The Hyundai Xcent is suitable for city travel, airport transfers, business meetings, family trips, sightseeing, hotel transfers, and outstation journeys from Pune."
},
{
"name": "Hyundai Xcent Tourist Vehicle Pune",
"description": "Choose Hyundai Xcent Tourist Vehicle Pune for comfortable sightseeing and private tourist transportation with an experienced chauffeur. Enjoy clean AC interiors, convenient pickup, comfortable seating, and flexible travel arrangements for couples, families, tourists, weekend travelers, and visitors exploring Pune or nearby destinations."
},
{
"name": "Hyundai Xcent Online Cab Booking Pune",
"description": "Make Hyundai Xcent Online Cab Booking Pune for convenient travel planning from your preferred pickup location. Schedule a comfortable chauffeur-driven Xcent according to your travel date, timing, passenger requirements, and destination for airport transfers, local rides, corporate travel, sightseeing, and outstation journeys."
},
{
"name": "Hyundai Xcent Cabs in Hinjewadi Pune",
"description": "Book Hyundai Xcent Cabs in Hinjewadi Pune for comfortable transportation to IT parks, offices, hotels, residential areas, Pune Airport, and nearby destinations. Professional chauffeurs provide convenient local, corporate, airport, and outstation travel for employees, business visitors, families, and tourists."
},
{
"name": "Hyundai Xcent Cabs in Kharadi Pune",
"description": "Choose Hyundai Xcent Cabs in Kharadi Pune for convenient transportation to offices, business parks, residential societies, hotels, Pune Airport, and other locations. Enjoy professional chauffeur service and comfortable AC sedan travel for corporate journeys, airport transfers, local rides, personal trips, and outstation travel."
},
{
"name": "Hyundai Xcent Cabs in Hadapsar Pune",
"description": "Reserve Hyundai Xcent Cabs in Hadapsar Pune for reliable local and outstation transportation with experienced drivers and comfortable AC interiors. The service is suitable for office travel, airport transfers, railway station drops, family journeys, business meetings, sightseeing, and private transportation from Hadapsar."
},
{
"name": "Hyundai Xcent Cabs in Baner Pune",
"description": "Book Hyundai Xcent Cabs in Baner Pune for comfortable private transportation with trained chauffeurs and convenient pickup arrangements. The service is suitable for corporate offices, hotels, residential areas, Pune Airport, local destinations, sightseeing trips, and outstation journeys from Baner."
},
{
"name": "Hyundai Xcent Cabs in Wakad Pune",
"description": "Choose Hyundai Xcent Cabs in Wakad Pune for convenient AC sedan transportation across Wakad, Hinjewadi, Pimpri Chinchwad, Pune Airport, and nearby destinations. Professional chauffeurs provide local, airport, corporate, sightseeing, one-way, round-trip, and outstation travel options."
},
{
"name": "Hyundai Xcent Cabs in Pimpri Chinchwad",
"description": "Book Hyundai Xcent Cabs in Pimpri Chinchwad for comfortable transportation throughout PCMC and to destinations across Maharashtra. The service is suitable for local rides, corporate travel, airport transfers, family journeys, sightseeing, railway station transfers, and outstation trips with professional chauffeur service."
},
{
"name": "Hyundai Xcent Cabs in Viman Nagar Pune",
"description": "Hire Hyundai Xcent Cabs in Viman Nagar Pune for convenient transportation near Pune Airport, hotels, offices, residential areas, and commercial destinations. Enjoy comfortable AC sedan travel, professional chauffeur service, timely pickup, and flexible options for airport transfers, corporate travel, local rides, and outstation journeys."
},
{
"name": "Hyundai Xcent Cabs in Kothrud Pune",
"description": "Choose Hyundai Xcent Cabs in Kothrud Pune for reliable private transportation with experienced chauffeurs and well-maintained AC sedans. The service is suitable for families, professionals, senior passengers, tourists, students, and business travelers requiring local rides, airport transfers, sightseeing, or outstation transportation."
},
{
"name": "Hyundai Xcent Cabs in Magarpatta Pune",
"description": "Book Hyundai Xcent Cabs in Magarpatta Pune for comfortable transportation to offices, residential areas, hotels, Pune Airport, and other destinations. Professional chauffeurs provide convenient travel for corporate employees, business visitors, families, airport passengers, and customers planning local or outstation journeys."
},
{
"name": "Hyundai Xcent Cabs in Wagholi Pune",
"description": "Reserve Hyundai Xcent Cabs in Wagholi Pune for convenient private transportation with professional chauffeurs and comfortable air-conditioned interiors. The service is suitable for airport transfers, office travel, residential pickups, family trips, local sightseeing, business journeys, and outstation travel from Wagholi."
},
{
"name": "Hyundai Xcent Cabs in Pune",
"description": "Book Hyundai Xcent Cabs in Pune for comfortable chauffeur-driven transportation across Pune and nearby destinations. Enjoy clean AC interiors, convenient pickup and drop facilities, professional drivers, and flexible travel options for local rides, airport transfers, corporate journeys, sightseeing, family travel, and outstation trips."
},
{
"name": "Hyundai Xcent Cab Service Pune",
"description": "Choose Hyundai Xcent Cab Service Pune for dependable private transportation with a comfortable sedan and experienced chauffeur. The service is suitable for local travel, airport transfers, office commuting, corporate meetings, family journeys, sightseeing, hotel transfers, one-way trips, and outstation travel."
},
{
"name": "Hyundai Xcent Taxi Service Pune",
"description": "Book Hyundai Xcent Taxi Service Pune for convenient point-to-point travel with comfortable AC interiors and professional chauffeur service. The vehicle is suitable for individuals, couples, families, corporate passengers, tourists, airport travelers, and customers requiring reliable transportation across Pune and nearby destinations."
},
{
"name": "Hyundai Xcent Cab Booking Pune",
"description": "Make Hyundai Xcent Cab Booking Pune for scheduled private transportation with convenient pickup and direct destination drop. Select the Xcent for local travel, airport transfers, business meetings, sightseeing, family trips, hotel transfers, one-way journeys, round trips, and outstation transportation."
},
{
"name": "Hyundai Xcent Car Rental Pune",
"description": "Hire Hyundai Xcent Car Rental Pune with a professional chauffeur for comfortable and convenient private travel. The sedan provides air-conditioned interiors and practical seating for city rides, airport transfers, corporate travel, family journeys, sightseeing, personal visits, and outstation trips."
},
{
"name": "Hyundai Xcent with Driver Pune",
"description": "Choose Hyundai Xcent with Driver Pune for hassle-free chauffeur-driven transportation throughout Pune and nearby destinations. Enjoy a comfortable AC sedan, professional driver service, convenient pickup, direct drop, luggage space, and flexible travel arrangements for business, family, airport, sightseeing, and outstation journeys."
},
{
"name": "Hyundai Xcent Outstation Cab Pune",
"description": "Book Hyundai Xcent Outstation Cab Pune for comfortable intercity transportation with an experienced chauffeur and well-maintained AC sedan. The service is suitable for one-way and round-trip journeys to Maharashtra destinations and other cities for family travel, business trips, sightseeing, personal visits, and weekend travel."
},
{
"name": "Hyundai Xcent Airport Cab Pune",
"description": "Reserve Hyundai Xcent Airport Cab Pune for convenient airport pickup and drop transportation with a professional chauffeur. Enjoy comfortable AC travel, luggage assistance, scheduled pickup, and direct transfers to or from Pune Airport for individuals, families, corporate travelers, tourists, and business passengers."
},
{
"name": "Online Hyundai Xcent Booking Pune",
"description": "Make Online Hyundai Xcent Booking Pune for convenient and scheduled private transportation. Reserve the vehicle according to your preferred date, pickup time, destination, passenger requirements, and journey type for local rides, airport transfers, corporate travel, sightseeing, one-way journeys, round trips, and outstation travel."
},
{
"name": "Hyundai Xcent Sedan Cab Pune",
"description": "Choose Hyundai Xcent Sedan Cab Pune for comfortable chauffeur-driven transportation with practical seating, AC interiors, luggage space, and convenient pickup arrangements. The sedan is suitable for individuals, couples, families, corporate travelers, airport passengers, tourists, and customers planning local or outstation journeys."
},
{
"name": "Hyundai Xcent Cab Hire Pune",
"description": "Hire Hyundai Xcent Cab Hire Pune for a private and comfortable journey with an experienced chauffeur. Enjoy convenient pickup, air-conditioned interiors, professional driver service, and flexible travel options for local transportation, airport transfers, corporate meetings, family trips, sightseeing, and outstation travel."
},
{
"name": "Hyundai Xcent Car Hire Pune",
"description": "Book Hyundai Xcent Car Hire Pune with a professional driver for convenient private transportation across Pune and nearby destinations. The comfortable AC sedan is suitable for business travel, airport transfers, family journeys, sightseeing, hotel transfers, personal visits, one-way trips, and round-trip outstation travel."
}
],
"tableData": [
["Xcent Cab Service in Pune", "Hyundai Xcent Rental Pune"],
["Hyundai Xcent Taxi Booking Pune", "Sedan Cab Service Pune"],
["Hyundai Xcent Car Booking Pune", "Xcent Outstation Cab Pune"],
["Hyundai Xcent Airport Transfer Pune", "Pune Xcent Car Hire"],
["Hyundai Xcent Tourist Vehicle Pune", "Hyundai Xcent Online Cab Booking Pune"],
["Hyundai Xcent Cabs in Hinjewadi Pune", "Hyundai Xcent Cabs in Kharadi Pune"],
["Hyundai Xcent Cabs in Hadapsar Pune", "Hyundai Xcent Cabs in Baner Pune"],
["Hyundai Xcent Cabs in Wakad Pune", "Hyundai Xcent Cabs in Pimpri Chinchwad"],
["Hyundai Xcent Cabs in Viman Nagar Pune", "Hyundai Xcent Cabs in Kothrud Pune"],
["Hyundai Xcent Cabs in Magarpatta Pune", "Hyundai Xcent Cabs in Wagholi Pune"],
["Hyundai Xcent Cabs in Pune", "Hyundai Xcent Cab Service Pune"],
["Hyundai Xcent Taxi Service Pune", "Hyundai Xcent Cab Booking Pune"],
["Hyundai Xcent Car Rental Pune", "Hyundai Xcent with Driver Pune"],
["Hyundai Xcent Outstation Cab Pune", "Hyundai Xcent Airport Cab Pune"],
["Online Hyundai Xcent Booking Pune", "Hyundai Xcent Sedan Cab Pune"],
["Hyundai Xcent Cab Hire Pune", "Hyundai Xcent Car Hire Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Hyundai Xcent Cabs in Pune for Comfortable City Travel",
    WhyChoosedescription: "Garud Cab Service provides Hyundai Xcent cab options in Pune for airport transfers, local transportation, business visits, family travel, railway station drops, and suitable outstation journeys."
  },
  {
    WhyChooseheading: "Practical Sedan for Daily Transportation",
    WhyChoosedescription: "The Hyundai Xcent is a compact sedan option for passengers who want comfortable seating, convenient city mobility, and useful boot space for everyday travel around Pune."
  },
  {
    WhyChooseheading: "Convenient Pune Airport Pickup & Drop",
    WhyChoosedescription: "Book a Hyundai Xcent for Pune Airport transfers when you need a comfortable sedan for travelling between the airport, home, hotel, office, or another preferred location."
  },
  {
    WhyChooseheading: "Suitable for Business & Office Travel",
    WhyChoosedescription: "The cab can be used for client meetings, office visits, business appointments, interviews, corporate transfers, and other professional travel requirements where a compact sedan is convenient."
  },
  {
    WhyChooseheading: "Comfortable Option for Couples & Small Families",
    WhyChoosedescription: "Hyundai Xcent is a practical choice for couples and small families travelling with moderate luggage, offering a private cabin experience without requiring a larger vehicle."
  },
  {
    WhyChooseheading: "Local Pune & Outstation Availability",
    WhyChoosedescription: "Use the Hyundai Xcent for city transportation or discuss suitable outstation routes from Pune for family visits, short holidays, religious trips, and intercity travel."
  },
  {
    WhyChooseheading: "One-Way and Return Travel",
    WhyChoosedescription: "Arrange a one-way drop when you only need transportation to your destination, or select a return journey for appointments, sightseeing, family visits, and planned outstation trips."
  },
  {
    WhyChooseheading: "Book Hyundai Xcent with Garud Cab Service",
    WhyChoosedescription: "Share your pickup location, destination, travel date, passenger details, luggage requirement, and trip type with Garud Cab Service to arrange a suitable Hyundai Xcent cab in Pune."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Hyundai Xcent Cabs in Pune?",
    answer: "Yes, Garud Cab Service provides Hyundai Xcent cab options in Pune for local travel, airport transfers, corporate trips, family transportation, railway station transfers, and suitable outstation journeys."
  },
  {
    question: "Can I book a Hyundai Xcent for Pune Airport?",
    answer: "Yes, Hyundai Xcent cabs can be arranged for Pune Airport pickup and drop services according to your travel or flight schedule."
  },
  {
    question: "Is Hyundai Xcent suitable for small families?",
    answer: "Yes, the Hyundai Xcent is a practical sedan option for couples and small families travelling with a moderate amount of luggage."
  },
  {
    question: "Can I use Hyundai Xcent for corporate travel?",
    answer: "Yes, Hyundai Xcent cab service can be used for business meetings, client visits, office travel, interviews, and other professional transportation requirements."
  },
  {
    question: "Can I book Hyundai Xcent for outstation travel?",
    answer: "Yes, suitable outstation trips from Pune can be arranged with a Hyundai Xcent depending on the route, travel dates, and vehicle availability."
  },
  {
    question: "Can I book a one-way Hyundai Xcent cab?",
    answer: "Yes, one-way cab arrangements can be made when you require direct transportation from Pune to your selected destination."
  },
  {
    question: "Is round-trip Hyundai Xcent service available?",
    answer: "Yes, round-trip arrangements can be planned for sightseeing, family visits, business appointments, airport requirements, and outstation travel."
  },
  {
    question: "Can I book the cab for local Pune sightseeing?",
    answer: "Yes, Hyundai Xcent can be arranged for suitable local sightseeing, shopping trips, hotel transfers, and other city transportation requirements."
  },
  {
    question: "Is Hyundai Xcent available with a driver?",
    answer: "Yes, chauffeur-driven Hyundai Xcent travel can be arranged for customers who prefer private transportation with a professional driver."
  },
  {
    question: "How can I book a Hyundai Xcent Cab in Pune?",
    answer: "Share your pickup location, destination, travel date, passenger count, luggage requirement, and trip type with Garud Cab Service to arrange your Hyundai Xcent cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback: "I booked a Hyundai Xcent for a Pune Airport transfer and the compact sedan was convenient for my trip. The pickup arrangement made the airport journey simple.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anuja More",
    feedback: "We used a Hyundai Xcent for a family visit within Pune. The car was comfortable for our small group and had enough space for our luggage.",
    rating: 5
  }
];




  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hyundai Xcent Cabs in Pune",
  "image": "https://garudcabs.com/assets/images/hyundai-xcent-cabs-in-pune.webp",
  "description": "Book Hyundai Xcent Cabs in Pune with Garud Cab for comfortable, affordable, and reliable local, airport, and outstation travel. Get Hyundai Xcent rental and taxi booking services in Pune for one way trips, round trips, corporate travel, airport transfers, and convenient city transportation with professional cab service.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/hyundai-xcent-cabs-in-pune"
  }
};




  return (
    <div>


<Helmet>
  <title>Hyundai Xcent Cabs in Pune | Rental & Taxi Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Hyundai Xcent Cabs in Pune with Garud Cab for comfortable and affordable travel. Get Xcent rental and taxi booking services for local, airport, outstation, one way, and round trip journeys."
  />

  <meta
    name="keywords"
    content="Xcent Cab Service in Pune, Hyundai Xcent Rental Pune, Hyundai Xcent Taxi Booking Pune, Sedan Xcent Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Hydundaixcentcabinpune;